import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { authApi } from '../utils/authApi';
import { API_URL } from '../utils/config';
import './Auth.css';

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [devResetLink, setDevResetLink] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    setDevResetLink('');

    try {
      const response = await authApi.post('/auth/reset-password', { email });

      if (response.data.success) {
        setSuccess(
          response.data.message ||
            'If an account exists for that email, a password reset link has been sent.'
        );
        if (response.data.dev_reset_link) {
          setDevResetLink(response.data.dev_reset_link);
        }
        setEmail('');
      } else {
        setError(response.data.error || 'Failed to send reset email');
      }
    } catch (err: unknown) {
      const axiosErr = axios.isAxiosError(err) ? err : null;
      const msg =
        axiosErr?.response?.data?.error ||
        (axiosErr?.code === 'ERR_NETWORK' || axiosErr?.message === 'Network Error'
          ? `Cannot reach the API at ${API_URL}. Is the backend running?`
          : null) ||
        axiosErr?.message ||
        'An error occurred while sending the reset email';
      setError(typeof msg === 'string' ? msg : 'An error occurred while sending the reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Forensic AI</h1>
          <p>Reset your password</p>
        </div>

        {error && <div className="message error">{error}</div>}

        {success && <div className="message success">{success}</div>}

        {devResetLink && (
          <div className="message success" style={{ wordBreak: 'break-all' }}>
            <p style={{ margin: '0 0 8px' }}>Dev reset link (open in this browser):</p>
            <a href={devResetLink} className="auth-link">
              {devResetLink}
            </a>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="auth-input"
              placeholder="Enter your email address"
            />
          </div>

          <button type="submit" disabled={loading} className="auth-button">
            {loading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
            ) : (
              'Send Reset Link'
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            Remember your password?{' '}
            <Link to="/login" className="auth-link">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
